export class WireSchema {
  constructor(callback) {
    this.callback = void 0;
    this.callback = callback;
  }
  // deliberate noop: all the magic happens in update
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  connect() {}
  // deliberate noop: all the magic happens in update
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  disconnect() {}
  update({
    schema
  }) {
    if (Array.isArray(schema)) {
      this.callback(schema.map(_schema => _schema.get().properties));
    } else {
      this.callback(schema.get().properties);
    }
  }
}